import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { AlgorandContextProvider } from "./contexts/AlgorandWalletContext";
import { EthereumProviderProvider } from "./contexts/EthereumProviderContext";
import { SolanaWalletProvider } from "./contexts/SolanaWalletContext.tsx";
import { TerraWalletProvider } from "./contexts/TerraWalletContext.tsx";
import ErrorBoundary from "./ErrorBoundary";
import { theme } from "./muiTheme";
import { store } from "./store";
import './index.css';

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <ThemeProvider theme={theme} injectFirst>
                <CssBaseline />
                <ErrorBoundary>
                    <SnackbarProvider maxSnack={3}>
                        <SolanaWalletProvider>
                            <EthereumProviderProvider>
                                <TerraWalletProvider>
                                    <AlgorandContextProvider>
                                        <HashRouter>
                                            <App />
                                        </HashRouter>
                                    </AlgorandContextProvider>
                                </TerraWalletProvider>
                            </EthereumProviderProvider>
                        </SolanaWalletProvider>
                    </SnackbarProvider>
                </ErrorBoundary>
            </ThemeProvider>
        </Provider>
    </ErrorBoundary>,
    document.getElementById("root")
);
